import { render } from "./NavigateToTopButton.vue?vue&type=template&id=223d00ab&scoped=true"
import script from "./NavigateToTopButton.vue?vue&type=script&lang=js"
export * from "./NavigateToTopButton.vue?vue&type=script&lang=js"

import "./NavigateToTopButton.vue?vue&type=style&index=0&id=223d00ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223d00ab"]])

export default __exports__